export const COMPANY = {
  brand: 'Fast Repair',
  domain: 'fast.repair',
  legalName: 'ClickAhead Marketing Ltd',
  companyNumber: '14719973',
  vatNumber: '480019216',
  icoNumber: 'ZB605577',
  registeredOffice: 'Preston Park House, South Road, Brighton, England, BN1 6SB',
} as const;

/** One-sentence description of Fast Repair's role, reused in metadata and structured data. */
export const PLATFORM_SUMMARY =
  'Fast Repair (fast.repair) is an availability-first repair booking and job management platform. We match you with the independent local repair partner who can attend soonest, based on postcode coverage and real-time availability kept up to date by partners in the Fast Repair app. Fast Repair does not carry out repairs itself.';

/** The single, consistent account of mandatory partner checks. Keep in sync with the Terms and Due Diligence pages. */
export const PARTNER_CHECKS = [
  'Valid public liability insurance',
  'Identity and status as a registered company or sole trader',
  'Gas Safe registration for partners who carry out gas work',
] as const;

export const PARTNER_CHECKS_SUMMARY =
  'Before joining, every partner is checked for valid public liability insurance and their identity and status as a registered company or sole trader. Partners who carry out gas work are also checked for Gas Safe registration.';

export const COMMERCIAL_MODEL_SUMMARY =
  'Fast Repair is free for customers, with no customer booking fee. Partner repair businesses pay Fast Repair a fee for the customer enquiries they receive, and you pay the repair business directly for the repair.';

export const MATCHING_SUMMARY =
  'Our availability-first matching algorithm finds the local repair partner who can attend soonest for your job and postcode, using the real-time availability partners keep up to date in the Fast Repair app. It is not a price comparison, and you will see the partner’s name and pricing before you choose a time.';

export const APP_FEATURES_SUMMARY =
  'Manage your repair from booking to completion in the Fast Repair app, receive job updates, message your partner engineer and track their arrival on a live map. Live engineer tracking is available for every booking.';

export const MANUFACTURER_STATEMENT =
  'Fast Repair is independent and is not affiliated with, or authorised by, any appliance manufacturer.';
